// Smooth open/close animation for <details> elements in Kalü sections.
// Works around the native <details> "snap" behaviour by manually animating
// the content's height between 0 and scrollHeight.

(function () {
  const SELECTOR = '.kalu-composition__panel, .kalu-faq__item, .kalu-actives__card';
  const DURATION = 320;
  const EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getContent(details) {
    return Array.from(details.children).find((el) => el.tagName !== 'SUMMARY');
  }

  function animateOpen(details, content) {
    details.classList.remove('is-closing');
    details.setAttribute('open', '');
    const target = content.scrollHeight;
    content.style.overflow = 'hidden';
    content.style.height = '0px';
    content.offsetHeight; // force reflow
    content.style.transition = `height ${DURATION}ms ${EASING}`;
    content.style.height = target + 'px';

    let timer;
    const finish = () => {
      content.removeEventListener('transitionend', onEnd);
      if (timer) clearTimeout(timer);
      content.style.transition = '';
      content.style.height = '';
      content.style.overflow = '';
    };
    const onEnd = (e) => {
      if (e && e.propertyName !== 'height') return;
      finish();
    };
    content.addEventListener('transitionend', onEnd);
    timer = setTimeout(finish, DURATION + 80);
  }

  function animateClose(details, content) {
    const start = content.scrollHeight;
    content.style.overflow = 'hidden';
    content.style.height = start + 'px';
    content.offsetHeight; // force reflow
    content.style.transition = `height ${DURATION}ms ${EASING}`;
    content.style.height = '0px';

    // Sync card-level [open] transitions with the height animation
    // (border, shadow, transform) so they don't trail at the very end.
    details.classList.add('is-closing');
    details.removeAttribute('open');

    let timer;
    const finish = () => {
      content.removeEventListener('transitionend', onEnd);
      if (timer) clearTimeout(timer);
      details.classList.remove('is-closing');
      content.style.transition = '';
      content.style.height = '';
      content.style.overflow = '';
    };
    const onEnd = (e) => {
      if (e && e.propertyName !== 'height') return;
      finish();
    };
    content.addEventListener('transitionend', onEnd);
    timer = setTimeout(finish, DURATION + 80);
  }

  document.addEventListener('click', (event) => {
    if (reduceMotion) return;
    const summary = event.target.closest('summary');
    if (!summary) return;
    const details = summary.parentElement;
    if (!details || !details.matches || !details.matches(SELECTOR)) return;

    event.preventDefault();
    const content = getContent(details);
    if (!content) return;

    // Determine state from the actual attribute (not is-closing) so a click
    // mid-close re-opens correctly.
    const isOpen = details.hasAttribute('open');
    if (isOpen) {
      animateClose(details, content);
    } else {
      animateOpen(details, content);
    }
  });
})();
